import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";

import CustomerSelect from "../../common/CustomerSelect";
import CallTypeSelect from "../../common/CallTypeSelect";
import ProjectSelect from "../../common/ProjectSelect";
import UserSelect from "../../common/UserSelect";

import ReportFilters from "../ReportFiltersComponent";

const SalesPerformanceFilters = ({
  filters,
  onChange,
  fetchData,
  handleResetFilters,
  loading,
  exportDisabled
}) => (
  <ReportFilters
    onFetchClick={fetchData}
    onResetClick={handleResetFilters}
    title="Sales Performance"
    loading={loading}
    csvExportAvailable={false}
    exportDisabled={loading || exportDisabled}
    disabled={!filters.startDate || !filters.endDate}
  >
    <Row>
      <Col md={3}>
        <CustomerSelect
          onChange={onChange("customers")}
          placeholder="Select"
          label="Customer"
          value={filters.customers || []}
        />
      </Col>
      <Col md={3}>
        <ProjectSelect
          onChange={onChange("projects")}
          placeholder="Select"
          label="Project"
          value={filters.projects || []}
        />
      </Col>
      <Col md={3}>
        <CallTypeSelect
          isMulti
          onChange={onChange("callTypes")}
          placeholder="Select"
          label="Call Type"
          value={filters.callTypes || []}
        />
      </Col>
      <Col md={3}>
        <UserSelect
          isMulti
          onChange={(value) =>
            onChange("salespersons")(value.map((v) => v.value))
          }
          placeholder="Select"
          label="Salesperson"
          value={filters.salespersons || []}
        />
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          Start Date *
        </label>
        <input
          style={{
            padding: 8,
            border: "1px solid hsl(0,0%,80%)",
            width: "100%",
            borderRadius: 4
          }}
          type="date"
          value={filters.startDate || ""}
          onChange={(e) => onChange("startDate")(e.target.value)}
        />
      </Col>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          End Date *
        </label>
        <input
          style={{
            padding: 8,
            border: "1px solid hsl(0,0%,80%)",
            width: "100%",
            borderRadius: 4
          }}
          type="date"
          value={filters.endDate || ""}
          onChange={(e) => onChange("endDate")(e.target.value)}
        />
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          * Required Fields
        </label>
      </Col>
    </Row>
  </ReportFilters>
);
SalesPerformanceFilters.propTypes = {
  filters: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  exportDisabled: PropTypes.bool
};
export default SalesPerformanceFilters;
